'use strict';

var React = require('react');

module.exports = function (props) {
    return React.createElement('svg', Object.assign({ viewBox: '0 0 1024 1024' }, props), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M637.542 557.848c41.806-57.89 66.458-128.984 66.458-205.848 0-194.404-157.596-352-352-352s-352 157.596-352 352 157.596 352 352 352c76.864 0 147.958-24.652 205.848-66.458l338.152 386.458 128-128-386.458-338.152zM352 608c-141.384 0-256-114.616-256-256s114.616-256 256-256c141.382 0 256 114.616 256 256s-114.614 256-256 256z' })
    ));
};